<template>
    <div>
        <v-checkbox
            hide-details
            color="default"
            :on-icon="mdiCheckboxOutline"
            :off-icon="mdiCheckboxBlankOutline"
            class="mt-0"
            v-model="selectedFilterValues"
            :value="filterValue.value"
        >
            <template #label>
                {{ filterValue.value }}
                <template v-if="!filterValue.selected && filterValue.frequency !== null">
                    (<span v-if="filterValue.frequencyType === 'additive'">+</span>{{ filterValue.frequency }})
                </template>
            </template>
        </v-checkbox>
    </div>
</template>

<script lang="ts">
import { mdiCheckboxBlankOutline, mdiCheckboxOutline } from '@mdi/js';
import { PropType } from 'vue';
import { Vue } from 'vue-property-decorator';
import { FilterMetadata } from '../../../../../../declarations/result';

export default Vue.extend({
    name: 'LabelFilterValue',
    props: {
        value: {
            type: Array as PropType<string[]>,
            default(): string[] {
                return [] as string[];
            },
        },
        filterValue: {
            type: Object as PropType<FilterMetadata>,
            required: true,
        },
    },
    data() {
        return {
            mdiCheckboxBlankOutline,
            mdiCheckboxOutline,
        };
    },
    computed: {
        selectedFilterValues: {
            get(): string[] {
                return this.value;
            },
            set(values: string[]): void {
                this.$emit('input', values);
            },
        },
    },
});
</script>
